export const POSTCODE_COOKIE = "postcode";
export const PERSONALISATIONPOSTCODE_COOKIE = "personalisationPostcode";
export const REGISTRATIONBANNER_COOKIE = "registrationBanner";
export const CIVIC_COOKIE_CONTROL_COOKIE = "CookieControl";